require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./aumnerie-1-6.json") })
        }
      }, "path---aumnerie-1-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---aumnerie-1-6!./.cache/json/aumnerie-1-6.json
// module id = 343
// module chunks = 231608221292675